import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosPost from "../axios/axios-post";
import axiosPut from "../axios/axios-put";
import axiosDelete from "../axios/axios-delete";

const BASE_URL = "/special-offer";

export const SpecialOffersAPI = Object.freeze({
  getAll: createAsyncThunk(
    "get/special-offers",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, { params });
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  getOne: createAsyncThunk(
    "get/one-special-offer",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(`${BASE_URL}/${id}`);
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  create: createAsyncThunk(
    "post/special-offer",
    async (offerData, { rejectWithValue }) => {
      try {
        const response = await axiosPost.post(BASE_URL, offerData);
        return response.data;
      } catch (err) {
        return rejectWithValue(err);
      }
    }
  ),

  update: createAsyncThunk(
    "update/special-offer",
    async (data, { rejectWithValue }) => {
      try {
        const response = await axiosPut.put(`${BASE_URL}/${data.id}`, data);
        return response.data;
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),

  delete: createAsyncThunk(
    "delete/special-offer",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosDelete.delete(`${BASE_URL}/${id}`);
        return { id, ...response.data };
      } catch (err) {
        return rejectWithValue(
          err.response?.data?.message ?? err.response?.data ?? err.message
        );
      }
    }
  ),
});
